import React, { useEffect, useState, useRef } from "react";
import { getVacantLockers } from "../Utility/utility";
import '../App.css';

const VacantLockerTable = ({ searchType, searchValue, searchClicked }) => {
  /* =========================
   STATE
   ========================= */
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const startItem = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const endItem = Math.min(page * pageSize, total);
  const resultRef = useRef(null);
  /* =========================
     LOAD DATA
     ========================= */
  async function load() {
    setLoading(true);
    setStatusMessage("Searching lockers...");

    try {
      const response = await getVacantLockers(
        searchType,
        searchValue,
        page,
        pageSize
      );

      const items = response?.items || [];
      const totalRecords = response?.total || 0;

      setRows(items);
      setTotal(totalRecords);
      setTimeout(() => {
        resultRef.current?.focus();
      }, 300);

      setStatusMessage(
        totalRecords > 0
          ? `${totalRecords} results found`
          : "No results found"
      );
    } catch (e) {
      setRows([]);
      setTotal(0);
      setStatusMessage("No results found");
    }

    setLoading(false);
  }

  /* =========================
     EFFECT
     ========================= */
  useEffect(() => {
    if (!searchClicked) return;
    load();
  }, [searchClicked, page, pageSize]);

  //   useEffect(() => {
  //     load();
  //   }, [searchType, searchValue, page, pageSize]);

  const totalPages = total === 0 ? 0 : Math.ceil(total / pageSize);

  return (
    <>
      {/* =========================
          PAGE SIZE
         ========================= */}
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      >
        {statusMessage}
      </div>
      {/* =========================
    PAGE SIZE
   ========================= */}
      <div style={{ marginBottom: 12, marginTop: 80 }}>
        <label htmlFor="vacant-locker-page-size">
          Rows per page
        </label>

        <select
          id="vacant-locker-page-size"
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setPage(1);
          }}
        >
          <option
            value="10"
            aria-label="10 rows per page"
          >
            10 rows per page
          </option>

          <option
            value="20"
            aria-label="20 rows per page"
          >
            20 rows per page
          </option>

          <option
            value="50"
            aria-label="50 rows per page"
          >
            50 rows per page
          </option>

          <option
            value="100"
            aria-label="100 rows per page"
          >
            100 rows per page
          </option>
        </select>
      </div>

      {/* =========================
          TABLE
         ========================= */}
      <div
        id="locker-results"
        ref={resultRef}
        tabIndex="-1"
        role="region"
        aria-label="Vacant Locker Search Results"
        className="table-responsive"
        aria-live="polite"
        aria-busy={loading}
      >
        <table
          className="tender-table"
          aria-label="Vacant locker search results"
        >
          <caption className="sr-only">
            Vacant Locker Search Results
          </caption>
          <thead>
            <tr>
              {/* <th>Original ID</th> */}
              <th scope="col">Branch Code</th>
              <th scope="col">Branch Name</th>
              <th scope="col">Postal Code</th>
              <th scope="col">Total Vacant Locker</th>
            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            )}

            {!loading && rows.length === 0 && (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  No data available
                </td>
              </tr>
            )}

            {!loading &&
              rows.map((r, i) => (
                <tr key={i}>
                  {/* <td>{r.originalId}</td> */}
                  <td>{r.branchCode}</td>
                  <td>{r.branchName}</td>

                  <td>{r.postalCode}</td>
                  <td>{r.totalVacantLocker}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {/* =========================
          PAGINATION
         ========================= */}
      <div className="tender-pagination">
        <button
          aria-label="Previous Page"
          onClick={() => setPage(p => Math.max(1, p - 1))}
          disabled={page === 1}
        >
          Previous
        </button>

        <span>
          Showing {startItem} to {endItem} of {total} entries
        </span>

        <button
          aria-label="Next Page"
          onClick={() => setPage(p => Math.min(totalPages, p + 1))}
          disabled={page >= totalPages}
        >
          Next
        </button>
      </div>
    </>
  );
}

export default VacantLockerTable